import { inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { BookingService } from '@markant-platform/cartridge/data-access';
import { VariantsState } from './variants.store.types';
import { BookingState } from '@markant-platform/cartridge/model';

// TODO This is an initial store
export const INITIAL_STATE: VariantsState = {
  variants: [],
  bookedVariants: [],
  isLoading: false,
  isFetched: false,
  error: false,
};

export const VariantsStore = signalStore(
  { providedIn: 'root' },
  withState(INITIAL_STATE),
  withMethods((store, bookingService = inject(BookingService)) => ({
    async getBookedVariants(): Promise<void> {
      patchState(store, { isLoading: true });
      try {
        const bookedVariants = await firstValueFrom(
          bookingService.getBookingsForUser([
            BookingState.BOOKED,
            BookingState.ACCEPTED,
            BookingState.PENDING,
            BookingState.TO_BE_CANCELLED,
            BookingState.ENDED,
          ])
        );
        patchState(store, { bookedVariants: bookedVariants.result, isLoading: false, isFetched: true });
      } catch (error) {
        patchState(store, { isLoading: false, error: true });
      }
    },
  }))
);
